import $ from "./index235.js";
import { resolveComponent as h, createElementBlock as n, openBlock as t, normalizeClass as p, createElementVNode as a, withDirectives as C, createCommentVNode as l, withKeys as f, withModifiers as m, toDisplayString as d, createBlock as g, renderSlot as E, normalizeStyle as F, Fragment as v, renderList as b, vShow as M } from "vue";
/* empty css         */
import S from "./index231.js";
const B = ["data-component"], N = { class: "bg-white" }, z = { class: "cursor-pointer cs-autocomplete-dropdown__wrapper" }, D = ["value", "inputmode", "disabled"], I = { class: "cs-autocomplete-dropdown__label text-text-l" }, K = {
  key: 0,
  class: "flex items-center justify-center h-full ml-8"
}, L = {
  key: 1,
  class: "flex items-center justify-center h-full ml-8"
}, V = {
  key: 0,
  class: "self-center w-24 h-24"
}, j = {
  key: 0,
  class: "mt-12 text-caption text-color-alert-negative-100",
  "data-test-id": "error"
}, H = {
  key: 0,
  class: "relative pb-16 font-bold text-caption after:w-full after:h-1 after:bottom-8 after:absolute after:bg-color-neutral-grey-10"
}, P = ["data-index", "onMousedown", "onMouseenter"], T = {
  key: 0,
  class: "text-caption",
  "data-test-id": "label"
}, U = {
  key: 1,
  class: "absolute top-8 right-8 text-caption text-color-neutral-grey-60"
};
function A(e, s, q, G, J, O) {
  const c = h("ms-disabled"), w = h("ms-warning"), y = h("ms-close");
  return t(), n("div", {
    "data-component": e.$options.name,
    class: p(["relative cs-autocomplete-dropdown", {
      "-filled": e.isFilled,
      "-focus": e.hasFocus,
      "-error": e.hasError && !e.isInactive,
      "-inactive": e.isInactive
    }])
  }, [
    a("div", N, [
      a("label", z, [
        a("input", {
          ref: "input",
          class: "cs-autocomplete-dropdown__input text-text-l",
          type: "text",
          value: e.modelValue,
          inputmode: e.inputmode,
          disabled: e.disabled || e.isInactive,
          onBlur: s[0] || (s[0] = (...o) => e.onBlur && e.onBlur(...o)),
          onFocus: s[1] || (s[1] = (...o) => e.onFocus && e.onFocus(...o)),
          onInput: s[2] || (s[2] = (...o) => e.onModelUpdate && e.onModelUpdate(...o)),
          onKeyup: [
            s[3] || (s[3] = f(m((...o) => e.highlightNext && e.highlightNext(...o), ["prevent"]), ["down"])),
            s[4] || (s[4] = f(m((...o) => e.highlightPrevious && e.highlightPrevious(...o), ["prevent"]), ["up"])),
            s[5] || (s[5] = f((...o) => e.onEnter && e.onEnter(...o), ["enter"]))
          ],
          onKeydown: s[6] || (s[6] = f((...o) => e.onTab && e.onTab(...o), ["tab"]))
        }, null, 40, D),
        a("span", I, d(e.label), 1),
        e.isInactive || e.hasError ? (t(), n("span", K, [
          e.isInactive ? (t(), g(c, {
            key: 0,
            class: "self-center w-24 h-24"
          })) : e.hasError ? (t(), g(w, {
            key: 1,
            class: "self-center w-24 h-24"
          })) : l("", !0)
        ])) : l("", !0),
        e.$slots.icon || e.isFilled ? (t(), n("span", L, [
          e.$slots.icon && !e.isFilled ? (t(), n("span", V, [
            E(e.$slots, "icon", {}, void 0, !0)
          ])) : (t(), g(y, {
            key: 1,
            class: "self-center w-24 h-24",
            onClick: m(e.onClear, ["stop"])
          }, null, 8, ["onClick"]))
        ])) : l("", !0)
      ]),
      e.hasError && !e.isInactive ? (t(), n("div", j, d(e.errorMsg), 1)) : l("", !0)
    ]),
    C(a("div", {
      ref: "wrapper",
      class: p(["absolute left-0 right-0 p-16 overflow-hidden text-left translate-y-8 bg-white border border-solid shadow border-color-neutral-grey-10 top-full border- z-expanding-nav rounded-normal", {
        "overflow-y-scroll": e.heightLimit
      }]),
      "data-test-id": "suggestions",
      style: F({
        "max-height": e.heightLimit
      })
    }, [
      (t(!0), n(v, null, b(e.computedSuggestions, (o, i) => (t(), n("div", {
        key: "group-" + i,
        class: p({
          "mt-16": i > 0
        })
      }, [
        o.title ? (t(), n("div", H, d(o.title), 1)) : l("", !0),
        (t(!0), n(v, null, b(o.items, (r, u) => (t(), n("div", {
          key: "group-" + i + "-" + u,
          ref_for: !0,
          ref: "suggestionsItems",
          class: p(["relative p-8 cursor-pointer select-none", {
            "bg-color-brand-beige-50 rounded-normal": e.isHighlighted(i, u),
            "-indented": r.isIndented,
            "after:h-1 after:w-full after:absolute after:left-0 after:-bottom-8 after:bg-color-neutral-grey-10 mb-16": e.showSeparators && u < o.items.length - 1
          }]),
          "data-test-id": "suggestion",
          "data-index": [i, u],
          onMousedown: (k) => e.onSuggestionClick(r),
          onMouseenter: (k) => e.setCurrentHighlighted(i, u)
        }, [
          r.label ? (t(), n("div", T, d(r.label), 1)) : l("", !0),
          a("div", null, d(r.text), 1),
          r.additionalInfo ? (t(), n("div", U, d(r.additionalInfo), 1)) : l("", !0)
        ], 42, P))), 128))
      ], 2))), 128))
    ], 6), [
      [M, e.showSuggestions]
    ])
  ], 10, B);
}
const Y = /* @__PURE__ */ S($, [["render", A], ["__scopeId", "data-v-f6b38de5"]]);
export {
  Y as default
};
